export const siteInfo = {
  name: '伦理在线',
  tagline: '伦理学习与道德资源平台',
  description: '伦理在线是专注伦理学知识、道德教育与职业伦理资源的在线平台。提供伦理课程、案例分析、伦理测评及专家解读，帮助个人与机构系统建立伦理认知体系，提升道德决策能力。',
  url: 'https://lunlizx.com',
  logo: '伦理在线',
  foundingYear: 2018,
  email: 'contact@lunlizx.com',
  phone: '400-888-9999',
  address: '北京市海淀区中关村南大街5号伦理大厦12层',
  social: {
    wechat: '伦理在线',
    weibo: '@伦理在线',
  },
  stats: {
    articles: 2560,
    users: 380000,
    experts: 86,
    courses: 120,
  },
};